import { render, staticRenderFns } from "./ValidationPageTemplate.vue?vue&type=template&id=f8780dac&scoped=true&"
import script from "./ValidationPageTemplate.vue?vue&type=script&lang=js&"
export * from "./ValidationPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ValidationPageTemplate.vue?vue&type=style&index=0&id=f8780dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8780dac",
  null
  
)

export default component.exports